export default "__VITE_ASSET__9451b23d__"